import { render } from "./subheader.vue?vue&type=template&id=70466725"
import script from "./subheader.vue?vue&type=script&lang=js"
export * from "./subheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__